/**
 * Builds `user.username` from the portal JWT claims.
 *
 * The claims are not guaranteed to hold a name. Both can be empty strings — which the old
 * `firstName + " " + lastName` concatenation turned into `" "`, the value that reached
 * Salesforce in IO-154 — or absent entirely, which turned into the literal string
 * `"undefined undefined"`. The second is the more dangerous of the two: it contains a space,
 * so `isIncompleteCustomerName` accepts it as a complete name and it sails past every guard.
 *
 * Either way we want an empty string, so the customer name fallback can recognise that there
 * is no usable name to fall back on.
 */
export function buildUserName(firstName?: unknown, lastName?: unknown): string {
    const first = typeof firstName === "string" ? firstName.trim() : "";
    const last = typeof lastName === "string" ? lastName.trim() : "";

    return [first, last].filter(part => part !== "").join(" ");
}
